import { render } from "./DBLinkedDataForm.vue?vue&type=template&id=34fb0ee4&ts=true"
import script from "./DBLinkedDataForm.vue?vue&type=script&lang=ts"
export * from "./DBLinkedDataForm.vue?vue&type=script&lang=ts"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__